import PropTypes from 'prop-types'
import React from 'react'
import { calcWidthHeightSet } from '../../utils/calcFrame'
import perMeterCalc from '../../utils/perMeterCalc'
import { Product, Set } from './theme'

const calcWidthHeight = (frames, perMeter) => {
  const result = calcWidthHeightSet(frames, perMeter)
  if ('width' in result && 'height' in result) {
    return result
  }

  return { width: 0, height: 0 }
}

const PreviewSet = ({ index, onSelect, selected, isSelected = false, perMeter, frames = [] }) => (
  <Set
    w={calcWidthHeight(frames, perMeter).width}
    h={calcWidthHeight(frames, perMeter).height}
    isSelected={isSelected}
    isDragSelected={selected && !!selected.find(s => (s.id === index && s.type === 'set'))}
    onClick={onSelect}
  >
    {frames.map(({ width = 0, height = 0, x = 0, y = 0, crop = { width: 100, height: 100, x: 0, y: 0 } }, i) => (
      <Product
        key={i}
        w={perMeterCalc(width, perMeter)}
        h={perMeterCalc(height, perMeter)}
        x={perMeterCalc(x, perMeter)}
        y={perMeterCalc(y, perMeter)}
        crop={crop}
      />
    ))}
  </Set>
)

PreviewSet.propTypes = {
  frames: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    })
  ),
  onSelect: PropTypes.func.isRequired,
  perMeter: PropTypes.number.isRequired,
  isSelected: PropTypes.bool,
}

export default PreviewSet



// WEBPACK FOOTER //
// ./src/components/PreviewSet/index.js